module.exports = __webpack_public_path__ + "img/Canoe-Sprint.5fc23c75.png";